import {
    Service,
    DrawerService,
} from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { DrawerName } from '@framework/workbench/drawer/constants';
import React from 'react';
import { AiReviewDrawerContent } from '@framework/workbench/ui/ai-review/components/ai-review-drawer-content';
import i18n from '@i18next/i18n';

interface IDrawerOption {
    aiPrompt: string;
}

@Service()
export class AiReviewService extends BaseToolbarFeature {
    public constructor(private readonly drawerService: DrawerService) {
        super();
    }

    public showDrawer = async () => {
        const contentJsonString = await this.getAppService().editableServiceLayer?.aiAssistantService
            .extractSlideContentAsJsonString();

        this.drawerService.showRightDrawer({
            name: DrawerName.SLIDE_RATING_DRAWER,
            title: `AI ${i18n.t('文本订正')}`,
            content: <AiReviewDrawerContent
                aiPrompt={contentJsonString || ''}
            />,
            onClose: () => {
                this.getAppService().editableServiceLayer?.drawerStateManager.promise().then((manager) => {
                    manager.handleDrawerHolderVisiable(false);
                    window.dispatchEvent(new Event('resize'));
                });
            },
            showCloseButton: true,
        });

        this.getAppService().editableServiceLayer?.drawerStateManager.promise().then((manager) => {
            manager.handleDrawerHolderVisiable(true);
            window.dispatchEvent(new Event('resize'));
        });
    };
}
